import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';
import styles from './Winner.module.css';

export const Winner = ({ winners }) => {
  const isOneWinner = winners.length <= 1;

  const errorHandler = (e, channel) => {
    e.target.src = iconsSources[channel];
  };

  return (
    <div className={`${styles.container}`}>
      <div className={styles.title}>
        {isOneWinner ? 'победитель!' : 'победители!'}
      </div>
      <div className={`${styles.winnersBlock}`}>
        {winners.length !== 0 &&
          winners.slice(0, 3).map((el, i) => {
            return (
              <div
                className={styles.winnersItem}
                key={el.id}
                style={{ '--delay': `${i * 0.5 + 1.5}s` }}>
                <div className={styles.avatarAndName}>
                  <div className={styles.avatarBlock}>
                    <img
                      className={styles.avatar}
                      src={
                        (el.message.image !== '1' && el.message.image) ||
                        iconsSources[el.message.channel]
                      }
                      onError={(e) => errorHandler(e, el.message.channel)}
                      alt="avatar"
                    />
                  </div>
                  <div className={styles.author}>
                    {el.message.author || hideNumber(el.message.senderNumber)}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};
